import { injectIntl } from 'react-intl';

const CookieBannerText = ({ intl }) => {
  // console.log(intl);
  // console.log(config);

  if (intl.locale === 'en') {
    return (
      <>
        To improve your experience on the platform and provide personalized
        services, we use cookies.{' '}
        <strong>
          By accepting, you will be able to use all the site's functionalities.
          By selecting "Reject Cookies", those that are not strictly necessary
          will be disabled
        </strong>
        . To choose which ones you want to authorize, select "Manage Cookies".
        Learn more in our{' '}
        <a
          href="https://www.gov.br/pt-br/termos-de-uso"
          target="_blank"
          rel="noreferrer"
          alt="opens in new tab"
        >
          Cookie Statement
        </a>
        .
      </>
    );
  }

  return (
    <>
      Para melhorar a sua experiência na plataforma e prover serviços
      personalizados, utilizamos cookies.{' '}
      <strong>
        Ao aceitar, você terá acesso a todas as funcionalidades do site. Se
        clicar em "Rejeitar Cookies", os cookies que não forem estritamente
        necessários serão desativados.
      </strong>{' '}
      Para escolher quais quer autorizar, clique em "Gerenciar cookies". Saiba
      mais em nossa{' '}
      <a
        href="https://www.gov.br/pt-br/termos-de-uso"
        target="_blank"
        rel="noreferrer"
        alt="abre em nova aba"
      >
        Declaração de Cookies
      </a>
      .
    </>
  );
};

export default injectIntl(CookieBannerText);
